/**
 * PolicyBadgesSection Component
 *
 * Displays policy badges for audit items, showing only triggered policies
 * Extracted from AuditItemContent to improve maintainability and follow component strategy patterns.
 */

import type { GraphQLAuditItem } from '@internal-audit/domain/graphql-types';
import { Badge, BadgeSize } from '@soteria/design-system-ve';

import * as styles from '../AuditItem.css';

interface PolicyBadgesSectionProps {
  item: GraphQLAuditItem;
}

export function PolicyBadgesSection({ item }: PolicyBadgesSectionProps) {
  const triggeredPolicies = item.contentSnapshot?.triggeredPolicies || [];

  // Only show policy section if there are triggered policies
  if (triggeredPolicies.length === 0) {
    return null;
  }

  return (
    <div className={styles.metadataItem}>
      <span className={styles.label}>Triggered Policies:</span>
      <div className={styles.labelBadges}>
        {triggeredPolicies.map(policy => (
          <Badge key={`triggered-${policy.id}`} size={BadgeSize.Small} text={policy.name} />
        ))}
      </div>
    </div>
  );
}
